import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { itemValue, menuItem } from './../../../modules/jarvis-ui/_models/index';
import { eExportType, Productrequest } from '../../../_models/precizion/productrequest';
import { RecommendationView, PrecizionRequest, Farm, CultivationPlot, Intervention, eTechInterType, ApiExportGroupDevices, StateExportConnectedRequest, ApiExportedFileConnectedDeviceModel } from './../../../_models/index';
import { PrecizionServices, GoogleAnalyticsService, ModalService, FarmerPrevisService } from './../../../_services/index'
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { LoadingService } from '../../../framework/auth/components/loading/loading.service';
import { HandleService } from './../../../_services/handle.service';
import { mcPreconisation } from '../../../_models/beapi/mcPreconisation';
import { isNullOrEmptyString, isNullOrUndefined } from '../../../_helpers';
import { ComboGroupRecords, ComboRecord } from '../../../_models/front/combox/ComboRecord';
import { _isNumberValue } from '@angular/cdk/coercion';
import { localStorageService } from '../../../_services/local-storage.service';

declare var originalAlert: any;

@Component({
  selector: 'console-window',
  templateUrl: './consolewindow.component.html',
  styleUrls: ['./consolewindow.component.scss', './consolewindow.component.responsive.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})


/**Component Export des préconisations vers les consoles */
export class ConsoleWindowComponent implements OnInit {


  /**Event propagé sur l'export de fichier*/
  @Output()
  public EmitedEventOnExportDevice: EventEmitter<itemValue> = new EventEmitter<itemValue>();

  /**Mode unique true: seul les perso sont affichées, false les perso et referentiel des modèles sont affichés */
  private _IsModePersonalOnly: boolean = ApiExportGroupDevices.MODE_USER_DEVICES_ONLY;
  private _opened = false;

  /**indique si on visualise le swith de modes: console modeles<->perso */
  private _showSwitchModeDevices: boolean = false;

  /**Indique si il dispose de consoles perso */
  private _includePersonalDevices: boolean = false;

  private formatDeviceMode = "console";
  private formatShapeFileMode = "shape";

  /**tooltip conditionné pour le switch mode device filter */
  get SwitchModePersonalOnlyTitle(): string {
    return this._IsModePersonalOnly ? "Passer en mode complet" : "Passer en mode que mes consoles";
  }

  /**style conditionné pour le switch mode device filter */
  get SwitchModePersonalOnlyStyle(): string {

    return this._showSwitchModeDevices && this._includePersonalDevices && this.isConsole ? "" : "visibility : hidden";
  }


  /**attribue le mode filtre des devices de la liste */
  set IsModePersonalOnly(value: boolean) {
    this._IsModePersonalOnly = value;
    this.BindComboxGroupedDevices(this.completdDevices, false, true)
  }

  /**Indique si on est en mode "QUE les consoles perso", false perso et modèles */
  get IsModePersonalOnly(): boolean {
    return this._IsModePersonalOnly;
  }

  @Input()
  set opened(value: boolean) {
    this._opened = value;

    if (value === true) {
      this.onPopinOpened();
    }
  }

  get opened(): boolean {
    return this._opened;
  }

  //apres ouverture de la popin
  private onPopinOpened(): void {
    this.ReloadDevices();
  }

  /**Indique si le référentiel des consoles est en cours de chargement */
  public IsRefDeviceInLoading: boolean = false;


  @Input()
  public ilot: Farm[];

  /**
  *Ensemble des Cultures User selectionnées
  */
  @Input()
  public SelectedCultivations: menuItem;
  @Output()
  public DialogClosed: EventEmitter<boolean> = new EventEmitter<boolean>();


  /**INDIQUE choix client, si il faut merger les parcelles */
  public blCbxMergePrecos: boolean = true;
  /**INDIQUE choix client, si il faut merger les parcelles avec leur culture differentes */
  public blCbxMergeDiffCultivation: boolean = false;

  /**en mode sleection de toutes les preco affichées */
  public grdCheckAllChecked: boolean = false;
  public existSelectable: boolean = false;
  public gridSelection: number = 0;
  public gridTotal: number = 0;
  /** ensemble des preconisations-produit du client */

  public gridPrecos: RecommendationView[] = [];

  public dataSaved: boolean = false;

  /**referentiel combox des consoles affichées */
  private completdDevices: ComboGroupRecords[] = [];
  /**referentiel combox des consoles affichées */
  public groupedDevices: ComboGroupRecords[] = [];
  /**la console selectionnée */
  public deviceSelected: ComboRecord | null = null;

  public BreakException: any = {};
  //format sélectionné [console|ShapeFile]
  public selectedFormat: string = null;
  /**Indique si on a sélectionné le format Console , false le format shapefile */
  public isConsole: boolean;
  private preconisationParcelle: RecommendationView[] = [];
  public selectableSettings: SelectableSettings;
  //Affiche les checkbox Multi Conseil/Ferti
  public CheckModeMulti: boolean = true;
  //etat de la combo preconisation
  public ChkPrecosFerti: boolean = false;
  //etat de la combo autres (modulations)
  public ChkOtherPrecos: boolean = false;
  //etat de la combo intervention mode preco(apport orga)
  public ChkInterModePreco: boolean = false;

  //etat de la combo Pilotage SP LAI preco
  public ChkPilotSpPreco: boolean = false;

  //etat de la combo farmer previs
  public ChkFarmerPrevis: boolean = false;

  //etat indispo de la combo preconisation
  public HiddenChkPrecosFerti: boolean = true;
  //etat indispo de la combo autres (modulations)
  public HiddenChkOtherPrecos: boolean = true;
  //etat indispo de la combo INtervention de preco (apport orga)
  public HiddenChkInterModePreco: boolean = true;

  //etat indispo de la combo Pilotage SP LAI preco
  public HiddenChkPilotSpPreco: boolean = true;
  //etat indispo de la combo farmer previs
  public HiddenChkFarmerPrevis: boolean = true;

  /**Valeur du Slide buffer */
  public SlideBufferValue: number = 0;
  //indique si le traitement d'export est en cours
  private _exportInProgress: boolean = false;

  //indique que les consoles viennent d'être initialisé
  private _isInitialiseDevices: boolean = false;

  public SlideTltp = "Elargir le contour des parcelles peut permettre de palier si besoin à l’imprécision du contour cartographique en bordure de parcelle. Recommandé pour les interventions à faible largeur de travail.";
  public get SlideTitle(): string {
    return 'Elargir le contour des parcelles  (' + this.SlideBufferValue + ' mètre' + (this.SlideBufferValue > 1 ? 's' : '') + ')';
  }

  /**retourne si le bouton export est verouillé (sans selection ou en cours d export) */
  public get disableExportButton(): boolean {
    return this.gridSelection == 0 || this._exportInProgress == true;
  }


  public ColumnUnit = "Unité cible (Shapefile)";
  public ColumnUnitTltp = "Pour l’export au format Shapefile, la préconisation sera convertie dans l’unité choisie.";

  //textes + tootlip des combobox merge de preconisations
  public CbxMergePlotPrecoTxt = "Regrouper les préconisations des parcelles adjacentes";
  public CbxMergeDiffCultTxt = "Regrouper même si cultures différentes";
  public CbxMergePlotPrecoTltp = "Fusionne les préconisations pour les parcelles adjacentes en une seule préconisation (culture, date d’apport et produit doivent être identiques).";
  public CbxMergeDiffCultTltp = "Les préconisations ayant le même produit et la même date seront fusionnées pour toutes les parcelles adjacentes, même si la culture est différente.";
  public IconPrevisFarmerTltp = "Intervention personnalisée";

  /**texte affiché en tooltip sur icone de recherche de console */
  public comboDeviceInfoTooltip = "Recherche selon : \n • Nom de console\n • Nom du compte connecté\n • Nom du modèle\n • Nom du constructeur\n • Groupement\n • 'USB'\n • 'personnel'\n • 'sans fil'"
  /**Texte affiché dans composant sur le placeHolder input de consoles */
  public defaultCbxDevicePlaceHolderText = 'Consoles';
  /**Texte affiché dans composant sur le placeHolder si erreur chargement de console de consoles */
  private defaultCbxDeviceErrorLoading = 'Erreur aucune console chargée';

  /**Texte affiché dans composant sur le placeHolder input de combox consoles */
  public ComboDevicePlaceHolder = this.defaultCbxDevicePlaceHolderText;

  /**texte sur icone info console */
  public iconInfoDeviceTooltip = "Les consoles peuvent être personnalisées via le bouton “Consoles” ";
  constructor(private _precizionServices: PrecizionServices, private _loadingService: LoadingService, private googleService: GoogleAnalyticsService, private modaleService: ModalService) { }


  ngOnInit() {
    this.initInteraction();
    //pour préserver les selections anterieur on ne reinitialise pas les selectedConsole -blCbxMergeDiffCultivation
    window.alert = originalAlert;
    this.loadingUserDevices();
  }


  private initInteraction() {
    this.CheckModeMulti = false;
    this.ChkOtherPrecos = false;
    this.ChkPrecosFerti = false;
    this.ChkInterModePreco = false;
    this.ChkPilotSpPreco = false;
    this.HiddenChkPrecosFerti = true;
    this.HiddenChkOtherPrecos = true;
    this.HiddenChkInterModePreco = true;
    this.HiddenChkPilotSpPreco = true;
    this.ChkFarmerPrevis = false;
    this.grdCheckAllChecked = false;
    this.existSelectable = false;
    this.gridSelection = 0;
    this.gridTotal = 0;
    this._exportInProgress = false;
    this.selectableSettings = {
      mode: "multiple"
    };

  }

  //#region Combox Devices

  /**
   * Chargement des consoles utilisateur et modèles
   */
  private loadingUserDevices() {

    this.IsRefDeviceInLoading = true;
    if ((this._precizionServices.GetMemoryGroupedComboDevices(false) == null)) {
      this._isInitialiseDevices = true;

      this._precizionServices.getExportableDevices().subscribe({
        next: (cbxGrpDevices) => {
          this.BindComboxGroupedDevices(cbxGrpDevices, true);

          this._isInitialiseDevices = false;
          this.IsRefDeviceInLoading = false;
        },
        error: (err) => {
          this.OnErrorLoadingDevices();
        }
      });

    }

    else if (this._precizionServices.GetMemoryGroupedComboDevices(false) != null) {
      this.BindComboxGroupedDevices(this._precizionServices.GetMemoryGroupedComboDevices(true) ?? [], true);
      this.IsRefDeviceInLoading = false;
    } else {
      this._isInitialiseDevices = false;
    }
  }


  /**
   * Attribution de la liste des devices pour la combox
   * sera filtrée selon la config :_configModeUnique =>x true seul les consoles perso affichées si présence
   * @param _iCompletComboGrpDevices liste de devices perso & referentiel
   * @param _iSetPreselected true on attribue celle preselectionnée
   *  @param _iCheckSelectedExist true si présente et !_iSetPreselected , à la base d'une selection contrôle qu elle existe tjs dans le referentiel, sinon applique la precedente
   */
  private BindComboxGroupedDevices(_iCompletComboGrpDevices: ComboGroupRecords[], _iSetPreselected: boolean, _iCheckSelectedExist: boolean = false) {
    this.completdDevices = _iCompletComboGrpDevices;

    this.setDeviceInputPlaceHolder(!this.completdDevices || this.completdDevices?.length == 0)

    //on est 1e accès
    if (this.isConsole == undefined) {
      if (_iCompletComboGrpDevices?.length > 0) {
        //on attribue le mode console ou shapefile

        if (_iCompletComboGrpDevices.find(t => t.GetPreSelected() != undefined) != undefined) {
          this.SelectionFormat(true);
        } else {
          //récupère le dernier choix selectionné depuis la mémoire
          //cas possible l export vers la console perso est plus dans la liste
          let mem = this.GetMemoryExportFormat();
          if (mem) {
            this.SelectionFormat(mem === this.formatDeviceMode)
          }
        }

      }
    }
    let filteredByMode: ComboGroupRecords[] = _iCompletComboGrpDevices;
    let existUserDevices = filteredByMode && filteredByMode.find(r => r.Code == ApiExportGroupDevices.CODE_GROUP_USER_DEVICES)?.Exists();
    this._includePersonalDevices = existUserDevices == true;
    if (this._IsModePersonalOnly == true && existUserDevices) {
      filteredByMode = filteredByMode.filter(r => r.Code == ApiExportGroupDevices.CODE_GROUP_USER_DEVICES);
    }

    this.BindFilteredComboxGroupedDevices(filteredByMode, _iSetPreselected, _iCheckSelectedExist);
  }

  /**
 * Attribution de la liste des devices pour la combox
 * @param _iComboGrpDevices liste de devices à afficher (filtré selon config)
 * @param _iSetPreselected true on attribue celle preselectionnée
 *  @param _iCheckSelectedExist true si présente et !_iSetPreselected , à la base d'une selection contrôle qu elle existe tjs dans le referentiel, sinon applique la precedente
 */
  private BindFilteredComboxGroupedDevices(_iComboGrpDevices: ComboGroupRecords[], _iSetPreselected: boolean, _iCheckSelectedExist: boolean = false) {

    this.groupedDevices = [..._iComboGrpDevices];
    if (_iComboGrpDevices?.length > 0) {
      if (!_iSetPreselected && _iCheckSelectedExist && this.deviceSelected?.Id) {

        let existing = false;
        _iComboGrpDevices.forEach((fGrp: ComboGroupRecords) => {
          if (fGrp?.Exists() == true) {

            let fnd = fGrp.GetById(this.deviceSelected?.Id ?? "")
            if (fnd) {
              existing = true;
            }
          }
        })
        if (!existing) {
          //elle n existe plus on supprime et reselectionne si présent
          this.deviceSelected = null;
          _iSetPreselected = true;

        }

      }
      if (_iSetPreselected) {

        this.deviceSelected = null;
        _iComboGrpDevices.forEach((fGrp: ComboGroupRecords) => {
          if (fGrp?.Exists() == true) {

            let fnd = fGrp.GetPreSelected();
            if (fnd) {
              this.deviceSelected = fnd;
            }
          }
        })

      }
    } else {
      this.setDeviceInputPlaceHolder(true);
      this.deviceSelected = null;
    }
  }

  /**Rechargement de la liste des consoles
   * gestion du cas modification des consoles perso en cours
   */
  private ReloadDevices() {

    if (this._isInitialiseDevices == false) {
      this.IsRefDeviceInLoading = true;
      if (this._precizionServices.IsRefreshInProcess()) {
        this.groupedDevices = [];
        this._precizionServices.WaitEndRefreshUserDevicesInProgress().subscribe(isInProgess => {
          //là il est censé les avoir reconstitué en mémoire
          if (this._precizionServices.GetMemoryGroupedComboDevices(false) != null) {

            this.BindComboxGroupedDevices(this._precizionServices.GetMemoryGroupedComboDevices(true) ?? [], true, true);
          }
          this.IsRefDeviceInLoading = false;
        }, error => {

           this.OnErrorLoadingDevices()
        });
      }

      else if (this._precizionServices.GetMemoryGroupedComboDevices(false) != null) {
        this.BindComboxGroupedDevices(this._precizionServices.GetMemoryGroupedComboDevices(true) ?? [], this.deviceSelected == null, true);
        this.IsRefDeviceInLoading = false;
      } else {
        this.IsRefDeviceInLoading = false;
      }
    }


  }

  /**
 * Sur selection d'une console dans la liste
 * @param _iSelection console selectionnée
 */
  public onGrpCbxDeviceSelectionChange(_iSelection: ComboRecord) {

    this.deviceSelected = _iSelection;
    //on enregistre l etat preselection 
    this._precizionServices.ChangeMemorySelectedDevice(_iSelection);
  }

  /**Sur une erreur de chargement des consoles */
  private OnErrorLoadingDevices() {
    this._isInitialiseDevices = false;
    this.IsRefDeviceInLoading = false;
    this.BindComboxGroupedDevices([], false, false);

    this.setDeviceInputPlaceHolder(true);

    this.modaleService.Error('Chargement des consoles', 'Une erreur est survenue durant la récupération des consoles.')

  }

  /**Attribue le texte console ou consoel en erreur */
  private setDeviceInputPlaceHolder(_iIsErrorLoading: boolean) {
    this.ComboDevicePlaceHolder = _iIsErrorLoading == true ? this.defaultCbxDeviceErrorLoading : this.defaultCbxDevicePlaceHolderText;
  }


  //#endregion

  /**
  * Selection des combo des formats
  *
  * @param _isSelectConsole true selection console false preselection shape
  */
  private SelectionFormat(_isSelectConsole: boolean) {
    this.selectedFormat = _isSelectConsole ? this.formatDeviceMode : this.formatShapeFileMode;
    this.isConsole = _isSelectConsole;

  }

  public close() {
    this.opened = false;
    this.DialogClosed.emit(this.opened);
    this.gridPrecos.forEach(a => { a.IsChecked = false })
    this.SetGridPrecos(this.preconisationParcelle);

  }
  public submit() {

    this.dataSaved = true;
    this._exportInProgress = true;
    let param: PrecizionRequest = new PrecizionRequest();
    let IlotWithPrecos: Farm[] = this.ilot && this.ilot.length > 0 ? this.ilot.filter(r => !r.IsDiagnostic()) : null;
    if (!IlotWithPrecos) {
      this.UserAlerte("Aucune exploitation sélectionnée");
      this._exportInProgress = false;
      return;
    }
    IlotWithPrecos.forEach(element => {
      if (element.IdExploitation)
        param.FarmIds.push(element.IdExploitation);
    });
    param.BufferSize = this.SlideBufferValue;
    param.CampaignId = IlotWithPrecos[0].IdCampagne;
    param.blMergePrecos = this.blCbxMergePrecos;
    param.blMergePlotSameCulture = this.blCbxMergePrecos == true ? this.blCbxMergeDiffCultivation == false : true;

    //convertion des unités selon choix client
    //voir si necessaire de connaitre le mode shapefile de la console
    let include_change_unit = true;
    this.gridPrecos.forEach(a => {

      if (a.IdRecommendation && a.IsChecked) {

        let change_to_unit_key = null;
        // si en shape et une unité est selectionné != de la préselectionnée on modifiera l unité en export shape
        if (include_change_unit == true && a.ConvertUnits && a.ConvertUnits.IsUnitChanged() == true) {
          change_to_unit_key = a.ConvertUnits.Selected_key;
        }

        param.Products.push(new Productrequest(a.CodeProduit, a, change_to_unit_key));
        if (a.OtherCodeProduit != null && a.OtherCodeProduit.length) {// include some other code of product
          a.OtherCodeProduit.forEach(othercode => {
            if (othercode != null)
              param.Products.push(new Productrequest(othercode, a, change_to_unit_key));
          })
        }
      }
    });

    if (!param.Products || !param.Products.length) {
      this.UserAlerte("Veuillez sélectionner au moins une préconisation.", false);
      this._exportInProgress = false;
      return;
    }

    if (param.Products.length > 1) {
      if (param.Products.findIndex(r => r.Type == eExportType.PilotSP || r.Type == eExportType.Preco) !== -1) {
        if (param.Products.findIndex(r => r.Type == eExportType.PrevisPrecAd || r.Type == eExportType.PrevisPrecSP) !== -1) {
          //en export il filtrera les preco qui ont un lien avec la previs exportée si présent
          param.ExcludePrecosOnPrevis = true;
        }
      }
    }
    this.LogOnAnalytics(param);

    let closeModale = true;
    if (this.isConsole) {
      if (this.deviceSelected != null) {

        this._loadingService.show("Veuillez patienter pendant la génération des fichiers de modulation");
        //si sur le modele Standard correspond a l id du model, si console perso son UID
        param.ConsoleId = this.deviceSelected.Id;
        //l'id du modèle lié de la console définit le format de l export
        param.ModelId = this.deviceSelected.Code;
        param.IsConnectedDevice = false;
        if (this.deviceSelected.Code !== this.deviceSelected.Id && this._precizionServices.GetMemoryRefApiDevices(false)) {
          //console perso
          let ref = this._precizionServices.GetMemoryRefApiDevices(true);
          let deviceFound = ref?.GetByUniqueId(this.deviceSelected.Id);
          if (deviceFound) {
            param.IsConnectedDevice = deviceFound.IsConnectedDevice;
            if (deviceFound.Manufacturer) {
              param.DeviceManufacturer = deviceFound.Manufacturer.Code ?? deviceFound.Manufacturer.Name;
            }

          }
        }

        closeModale = false;
        this._precizionServices.getConsoleDownload(param).subscribe(
          (response: ApiExportedFileConnectedDeviceModel) => {

            if (response && response.FileExporting)
              response = new ApiExportedFileConnectedDeviceModel(response.FileExporting, param.IsConnectedDevice);

            if (response?.Exists() && response.IsConnectedExport()) {
              this.loadingSendingConnectedStatus(response);
              this.propagateOpeningConnectedStatePopin(true, true);

              this.ClosingModal();

            } else {
              this.downloadingExportedFile(response.FileExporting);
              this.ClosingModal();
            }
          }
          ,
          error => {
            this._loadingService.hide();
              let msguser ="Une erreur est survenue durant la génération."
            if(this.IsReqSizeExceed(error)){

              var cmpl = param?.BufferSize>0 ? " et/ou l'élargissement des contours" : "";
              msguser = `Export impossible. Veuillez réduire le nombre de préconisations sélectionnées${cmpl}.`;
            }
          
            this.UserAlerte(msguser, true);
            closeModale = false;
          }
        );
      }
      else {
        this._exportInProgress = false;

        return;
      }


    } else {

      let isConnected = param.IsConnectedDevice;
      this._loadingService.show("Veuillez patienter pendant la génération des fichiers de modulation");
      this._precizionServices.getShapeDownload(param).subscribe(
        (response: ApiExportedFileConnectedDeviceModel) => {

          if (isConnected) {
            response = new ApiExportedFileConnectedDeviceModel(response.FileExporting, true);
          }

          if (isConnected && response?.Exists() && response.IsConnectedExport()) {
            this.loadingSendingConnectedStatus(response);
            this.propagateOpeningConnectedStatePopin(true, true);

          } else {
            this.downloadingExportedFile(response);
            this.ClosingModal();
          }

        },
        error => {
          this._loadingService.hide();
          let msguser ="Une erreur est survenue durant la génération."
          if(this.IsReqSizeExceed(error)){

            var cmpl = param?.BufferSize>0 ? " et/ou l'élargissement des contours" : "";
            msguser = `Export impossible. Veuillez réduire le nombre de préconisations sélectionnées${cmpl}.`;
          }
          
          this.UserAlerte(msguser, true);
          closeModale = false;
        });
    }
    this._exportInProgress = false;

    if (closeModale) {
      this.ClosingModal();
    }

  }

  private ClosingModal() {
    this.ngOnInit();
    this.close();
  }

  /**
   * Propage l event d'ouverture de la popin des status d'export connectés
   * @param _iSetFinished true ferme le loader et l'etat export en cours
   * @param _iClose true ferme la popin
   */
  private propagateOpeningConnectedStatePopin(_iSetFinished: boolean, _iClose: boolean) {

    if (_iSetFinished) {
      this._loadingService.hide();
      this._exportInProgress = false;
    }
    let openPop: itemValue = new itemValue();
    openPop.Id = "OPEN_POPIN_CONNECTED_STATES";
    openPop.Model = "OPEN_POPIN_CONNECTED_STATES";
    openPop.Value = "1";
    this.EmitedEventOnExportDevice.emit(openPop);

    if (_iClose) {
      setTimeout(() => {
        this.ngOnInit();
        this.close();
      }, 1000);

    }

  }

  /**
   * Downloading exported file serveur
   * @param fileDownloadReq file exported downloader informations
   */
  private downloadingExportedFile(fileDownloadReq: any) {
    if (fileDownloadReq && fileDownloadReq.Uid && fileDownloadReq.Name) {
      let errorMsg = "Une erreur est survenue durant la récupération du fichier généré.";

      this._precizionServices.downloadExportedFile(fileDownloadReq).subscribe(p => {
        if (!p) {
          this.UserAlerte(errorMsg, true);
        }
      },
        error => {

          this.UserAlerte(errorMsg, true);
        });

      this._loadingService.hide();
    } else {
      this._loadingService.hide();
      this.UserAlerte("Une erreur est survenue durant la génération.", true);
    }
    this._exportInProgress = false;
  }



  /**
   * Loading file tranfert stat
   * @param fileDownloadReq 
   */
  private loadingSendingConnectedStatus(fileDownloadReq: ApiExportedFileConnectedDeviceModel) {
    if (fileDownloadReq && fileDownloadReq.GetExportRequestUid()) {
      if (fileDownloadReq.FileExporting?.Connected.IsInProgress == true) {
        //on est sur un nouvel export connecté
        let fileReqUid: string | null = fileDownloadReq.GetExportRequestUid();
        let req = new StateExportConnectedRequest();
        if (fileReqUid) {
          req.requestUids.push(fileReqUid);
        }

        this._precizionServices.getStatesSendConnected(req, true, true, true).subscribe(p => {


        },
          error => {

          });
      } else {

        //le fichier est potentiellement en erreur
      }
    }
  }

  ngOnChanges(changes: any) {
    this.BindingPrecos();
  }

  /* retourne la date formaté pour le produit préfix d un - si !=null */
  private getProductDate(date: Date): any {
    let _return = HandleService.getLOCALDate(date);
    return _return != "" ? " - " + _return : _return;
  }


  public handleConsoleRadioCheckChanged(event: any) {
    this.SetMemoryExportFormat(this.selectedFormat);
    this.SelectionFormat(this.selectedFormat === this.formatDeviceMode)

  }

  /**
   * remplissage des precos- produit date pour les exploitations selectionnées
   * Selon la campagne et les cultures
   */
  BindingPrecos() {
    this.preconisationParcelle = [];
    this.gridPrecos = [];
    this.gridSelection = 0;
    this.gridTotal = 0;
    this.existSelectable = false;

    /*filtre sur les cultures selectionnées */
    let filterCultureIds = [];
    if (this.SelectedCultivations && this.SelectedCultivations.GroupItems && this.SelectedCultivations.GroupItems.length) {
      this.SelectedCultivations.GroupItems.forEach(clt => {
        filterCultureIds.push(clt.Id);
      }
      );
    }
    let blfilterClt = filterCultureIds.length > 0;
    let _blIncludePilotSPPreco = false;

    let manageFarmerPrevis = FarmerPrevisService.ConfigEnableDuplication() == true;

    if (this.ilot && this.ilot.length > 0) {
      let _ShapeConvertUnits = this._precizionServices.GetDatasShapeConvertUnits();

      this.ilot.forEach(farm => {
        if (farm.IsAnnualOrder() || farm.IsDiagPilotSPLAI())
          return;

        if (farm.Sectors && farm.Sectors.length > 0) {

          let _blPrecoFumure = !farm.PresTypeModulation();
          let _blIsPilotPreco = farm.IsOrderPilotSPLAI();

          farm.Sectors.forEach(ilot => {
            if (ilot.CultivationPlots && ilot.CultivationPlots.length > 0) {
              ilot.CultivationPlots.forEach(parcelle => {

                if (blfilterClt) {//filtre selon les cultures seelctionnées
                  if (parcelle.CultivationSelected && parcelle.CultivationSelected.Id && filterCultureIds.findIndex(e => e == parcelle.CultivationSelected.Id.toString()) > -1) {
                  }
                  else {
                    return;
                  }
                }

                let includeTechPrecoPrevis = manageFarmerPrevis && parcelle.InterPrevis.findIndex(e => e.SrcType == eTechInterType.Preconisation || e.SrcType == eTechInterType.PilotSp) != -1;

                //Ques les parcelles AVEC des precos
                if (parcelle.Preconisations && parcelle.Preconisations.length) {


                  parcelle.Preconisations.forEach((plPreco, index) => {

                    if (includeTechPrecoPrevis && parcelle.ExistPrevisTechPreconisation(plPreco.IdIntervention)) {
                      //on n'affiche pas les précos avec une prévis liée à la parcelle
                      return;
                    }

                    let _propIdent = plPreco.Ident;
                    let _propIdGroup = plPreco.IdGroupe;

                    /*Evite peter si Pas de fertilisant sur la preconisation*/
                    if (this.IsEmptyFertiDose(plPreco)) {
                      return;
                    }
                    if (_blPrecoFumure) {
                      if (_propIdent <= 0 || !this.IncludeMcPrecoDoseOnIdent(parcelle, _propIdent)) {//aucune micro ne dispose de dose >0
                        return;
                      }
                    }
                    else if (_propIdGroup == null || !this.IncludeMcModulationDoseOnIdGroup(parcelle, _propIdGroup)) {//Modulation
                      return;
                    }
                    let _elemdate: string = HandleService.getISODate(plPreco.BeginDate);
                    let selectedPlPreco = this.preconisationParcelle.find(a => a.EqualByOriginalName(plPreco.Fertilizer.Name) && _elemdate === a.Date && a.IsFarmerPrevis == false);

                    if (selectedPlPreco) {
                      // same Product ON date
                      let addedDose = plPreco.Fertilizer.Dose;
                      let existingDose = selectedPlPreco.Quantity;
                      existingDose = existingDose + addedDose;
                      selectedPlPreco.Quantity = existingDose;
                      if (selectedPlPreco.CodeProduit != null && plPreco.CodeProduit != null && plPreco.CodeProduit != selectedPlPreco.CodeProduit) {// same product  Name but different product code
                        if (!selectedPlPreco.OtherCodeProduit.length || selectedPlPreco.OtherCodeProduit.indexOf(plPreco.CodeProduit) < 0) {
                          selectedPlPreco.OtherCodeProduit.push(plPreco.CodeProduit)
                        }
                      }

                    } else {

                      if (_blIsPilotPreco == true) {
                        _blIncludePilotSPPreco = true;
                      }
                      let preco = new RecommendationView(plPreco, HandleService.getISODate(plPreco.BeginDate), false, _blPrecoFumure, false, _blIsPilotPreco);
                      //indique si on est sur une modulation en mode bouillie
                      let _isModulationBouillie = Intervention.IsModulationBouillie(plPreco);

                      let unit_on_area = " " + HandleService.FormatUnitOnArea(preco.Unit);
                      //Constitution du nom final à afficher dans la liste des Modulations
                      preco.Name = plPreco.Fertilizer.Name + unit_on_area + this.getProductDate(plPreco.BeginDate);
                      if (preco.Unit && _isModulationBouillie == false) {
                        //HORS mode bouillie
                        //on récupère la liste des unités de convertion possible
                        preco.ConvertUnits = this._precizionServices.GetShapeConvertUnit(preco.Unit, _ShapeConvertUnits);

                      }
                      this.preconisationParcelle.push(preco);
                    }
                  });
                }
                //Parcelles avec des interventions en mode préconisation
                if (parcelle.Interventions && parcelle.Interventions.length) {

                  parcelle.Interventions.forEach((plInter: Intervention, index) => {

                    let _blHasInterModePreco = plInter.ModePreco == true;

                    if (!_blHasInterModePreco) {
                      return;
                    }

                    if (this.IsEmptyFertiDose(plInter) || Intervention.IsInterDeleted(plInter) == true) {
                      return;
                    }

                    let _elemdate: string = HandleService.getISODate(plInter.BeginDate);

                    let selectedPlotIntervention = this.preconisationParcelle.find(a => a.EqualByOriginalName(plInter.Fertilizer.Name) && _elemdate === a.Date && a.IsFarmerPrevis == false);
                    if (selectedPlotIntervention) {
                      let addedDose = plInter.Fertilizer.Dose;
                      let existingDose = selectedPlotIntervention.Quantity;
                      existingDose = existingDose + addedDose;
                      selectedPlotIntervention.Quantity = existingDose;
                      if (selectedPlotIntervention.CodeProduit != null && plInter.CodeProduit != null && plInter.CodeProduit != selectedPlotIntervention.CodeProduit) {// same product  Name but different product code
                        if (!selectedPlotIntervention.OtherCodeProduit.length || selectedPlotIntervention.OtherCodeProduit.indexOf(plInter.CodeProduit) < 0) {
                          selectedPlotIntervention.OtherCodeProduit.push(plInter.CodeProduit)
                        }
                      }
                    } else {
                      let intervention = new RecommendationView(plInter, HandleService.getISODate(plInter.BeginDate), false, false, true);
                      let unit_on_area = " " + HandleService.FormatUnitOnArea(intervention.Unit);
                      intervention.Name = plInter.Fertilizer.Name + unit_on_area + this.getProductDate(plInter.BeginDate);
                      if (intervention.Unit) {

                        //on récupère la liste des unités de convertion possible
                        intervention.ConvertUnits = this._precizionServices.GetShapeConvertUnit(intervention.Unit, _ShapeConvertUnits);
                      }
                      this.preconisationParcelle.push(intervention);
                    }
                  })
                }

                if (parcelle.ExistInterPrevis() == true && manageFarmerPrevis == true) {
                  parcelle.InterPrevis.forEach((plPrevis, index) => {

                    let _propIdent = plPrevis.Ident;
                    /*Evite peter si Pas de fertilisant sur la preconisation*/
                    if (this.IsEmptyFertiDose(plPrevis)) {
                      return;
                    }
                    if (_propIdent <= 0 || !this.IncludeMcPrevisDoseOnIdent(parcelle, _propIdent)) {//aucune micro ne dispose de dose >0
                      return;
                    }
                    let _elemdate: string = HandleService.getISODate(plPrevis.BeginDate);
                    let selectedPlPreco = this.preconisationParcelle.find(a => a.EqualByOriginalName(plPrevis.Fertilizer.Name) && _elemdate === a.Date && a.IsFarmerPrevis == true);
                    if (selectedPlPreco) {
                      // same Product ON date
                      let addedDose = plPrevis.Fertilizer.Dose;
                      let existingDose = selectedPlPreco.Quantity;
                      existingDose = existingDose + addedDose;
                      selectedPlPreco.Quantity = existingDose;
                      if (selectedPlPreco.CodeProduit != null && plPrevis.CodeProduit != null && plPrevis.CodeProduit != selectedPlPreco.CodeProduit) {// same product  Name but different product code
                        if (!selectedPlPreco.OtherCodeProduit.length || selectedPlPreco.OtherCodeProduit.indexOf(plPrevis.CodeProduit) < 0) {
                          selectedPlPreco.OtherCodeProduit.push(plPrevis.CodeProduit)
                        }
                      }

                    } else {

                      let fPrevis = new RecommendationView(plPrevis, HandleService.getISODate(plPrevis.BeginDate), false, _blPrecoFumure, false, _blIsPilotPreco, true);

                      //indique si on est sur une modulation en mode bouillie
                      let _isModulationBouillie = Intervention.IsModulationBouillie(plPrevis);

                      let unit_on_area = " " + HandleService.FormatUnitOnArea(fPrevis.Unit);
                      //Constitution du nom final à afficher dans la liste des Modulations
                      fPrevis.Name = plPrevis.Fertilizer.Name + unit_on_area + this.getProductDate(plPrevis.BeginDate);
                      if (fPrevis.Unit && _isModulationBouillie == false) {
                        //HORS mode bouillie
                        //on récupère la liste des unités de convertion possible
                        fPrevis.ConvertUnits = this._precizionServices.GetShapeConvertUnit(fPrevis.Unit, _ShapeConvertUnits);

                      }
                      this.preconisationParcelle.push(fPrevis);
                    }
                  });
                }


              })
            }
          })
        }
      })
    }

    if (this.preconisationParcelle.length > 0) {
      //on selectionne les combos et conditionne l affichage combo selon la presence de preco de ce type
      this.ChkPrecosFerti = this.preconisationParcelle.findIndex(t => t.IsFumur) != -1;
      this.HiddenChkPrecosFerti = !this.ChkPrecosFerti;
      this.ChkInterModePreco = this.preconisationParcelle.findIndex(t => t.IsInterModePreco) != -1;
      this.HiddenChkInterModePreco = !this.ChkInterModePreco;

      this.ChkPilotSpPreco = _blIncludePilotSPPreco;
      this.HiddenChkPilotSpPreco = !_blIncludePilotSPPreco;

      this.ChkOtherPrecos = this.preconisationParcelle.findIndex(t => t.IsInterModePreco == false && t.IsFumur == false) != -1;
      this.HiddenChkOtherPrecos = !this.ChkOtherPrecos;
      this.ChkFarmerPrevis = this.preconisationParcelle.findIndex(e => e.IsFarmerPrevis) != -1;
      this.HiddenChkFarmerPrevis = !this.ChkFarmerPrevis;
    }

    this.CheckModeMulti = this.IsModeMultiFormat();

    if (this.CheckModeMulti)
      this.cbxFiltrePrecos();
    else
      this.SetGridPrecos(this.preconisationParcelle);
  }


  /**
   * Attribution des preconisations au grid+Order des produits
   *
   * @param _iUserPreconisations
   */
  private SetGridPrecos(_iUserPreconisations: RecommendationView[]) {
    this.gridPrecos = _iUserPreconisations;
    this.OrderPrecos(this.gridPrecos);
    this.existSelectable = this.gridPrecos?.length > 0;
    if (this.grdCheckAllChecked == true) {
      this.ChangeGridPrecoSelection(true);
    }
    this.gridTotal = this.gridPrecos?.length;
    this.updateSelectionCounter();
  }
  /**
   * Ordonne le tableau des preconisations
   */
  private OrderPrecos(_oPreconisations: RecommendationView[]) {
    if (_oPreconisations != null && _oPreconisations.length > 1) {
      _oPreconisations = _oPreconisations.sort(function (a, b) {
        return (isNullOrUndefined(a.OrderableName)) ? -1 : (isNullOrUndefined(b.OrderableName)) ? 1 : (a.OrderableName < b.OrderableName) ? -1 : (a.OrderableName > b.OrderableName) ? 1 : 0;
      })
    }
  }

  /**
   * show user message
   * @param _userMessage user message text
   * @param _iblAddContactSupport add text contact support if problem persist
   */
  private UserAlerte(_userMessage: string, _iblAddContactSupport: boolean = true) {

    let msg = _userMessage;
    if (_iblAddContactSupport == true) {
      msg += " Si le problème persiste, veuillez contacter votre support be Api."
    }
    this.modaleService.Error('Erreur export', msg)

  }

  //clic sur la combo Fusion de parcelle
  cbxMergePrecosClick() {
    this.blCbxMergePrecos = !this.blCbxMergePrecos;
    if (this.blCbxMergePrecos == false) {
      this.blCbxMergeDiffCultivation = false;
    }
  }

  //le client choisit sur le fait de fusionner sur des cultures differentes
  CbxMergeDiffCultivationsClick() {
    if (this.blCbxMergePrecos == true) {
      this.blCbxMergeDiffCultivation = !this.blCbxMergeDiffCultivation
    } else {
      this.blCbxMergeDiffCultivation = false;
    }

  }

  /**Filtre les précos selon checkbox types */
  cbxFiltrePrecos() {
    let _filterPrecos: RecommendationView[] = [];
    if (this.CountCheckBoxSelected() == 5) {
      _filterPrecos = this.preconisationParcelle;
    }
    else {
      this.preconisationParcelle.forEach(
        t => {

          if (t.IsFarmerPrevis == true) {
            //farmer previs on peut etre sur preco ou pilotsp 
            if (this.ChkFarmerPrevis) {
              _filterPrecos.push(t);
            }

          }
          else {
            if (t.IsPilotSPPreco && this.ChkPilotSpPreco) {
              _filterPrecos.push(t);
            } else if (t.IsInterModePreco && this.ChkInterModePreco) {
              _filterPrecos.push(t);
            }
            else if (t.IsInterModePreco == false && t.IsPilotSPPreco == false) {
              if ((this.ChkOtherPrecos && !t.IsFumur && !t.IsPilotSPPreco) || (this.ChkPrecosFerti && t.IsFumur))
                _filterPrecos.push(t);
            }
          }
        }
      )
    }


    this.SetGridPrecos(_filterPrecos);
  }

  /**
   * Event changement du status de la checkbox selection toute aucune preco
   */
  public onChangeCheckAll() {

    if (this.grdCheckAllChecked == true) {
      //swith vers unchecked
      this.ChangeGridPrecoSelection(false);
    } else {
      this.ChangeGridPrecoSelection(true);
    }
  }

  /**
   * Event selection preco grid
   * @param beforeChangeStatus le status precedent l action
   */
  public onChangePrecoSelection(beforeChangeStatus: boolean) {
    let isToUncheckChange = beforeChangeStatus == true;
    if (isToUncheckChange && this.grdCheckAllChecked == true && this.gridPrecos.length) {
      //il a déselectionné du grid une preco donc on retire l cbx global
      this.grdCheckAllChecked = false

    }

    this.updateSelectionCounter();
    if (this.gridPrecos.length) {
      //prendre en compte ce changement de status non comptabilisé
      if (isToUncheckChange) {
        this.gridSelection -= 1;
      } else {
        this.gridSelection += 1;
      }

    }

  }

  /**
   * Attribution du statut checkbox checked pour les données du grid
   */
  private ChangeGridPrecoSelection(_iSetChecked: boolean) {
    if (this.gridPrecos.length) {
      this.gridPrecos.forEach((fPreco: any) => {
        fPreco.IsChecked = _iSetChecked == true;
      });
    }
    this.updateSelectionCounter();
  }

  /**Comptabilise le nombre de preco du grid sélectionné */
  private updateSelectionCounter() {
    this.gridSelection = 0;
    if (this.gridPrecos.length) {
      this.gridSelection = this.gridPrecos.filter(r => r.IsChecked == true).length;
    }
  }
  /**
   * Controle si on est dans un cas d'export multiformat
   * plus d un format
   * @return bool
   */
  private IsModeMultiFormat() {
    return this.CountCheckBoxSelected() > 1;
  }

  private CountCheckBoxSelected(): number {
    let selections: Boolean[] = [this.ChkOtherPrecos, this.ChkPrecosFerti, this.ChkPilotSpPreco, this.ChkInterModePreco, this.ChkFarmerPrevis];
    return HandleService.CountOccurenceKey(selections, true);
  }

  /**
   * Controle qu il dispose d au - 1 modulation Micro
   * @param CultivationPlot
   * @param iModIdGroupe
   */
  private IncludeMcModulationDoseOnIdGroup(CultivationPlot: CultivationPlot, iModIdGroupe: any): boolean {
    if (CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
      return CultivationPlot.MicroPlots.findIndex(mc => mc.Preconisations && this.IncludeFertiDose(this.GetModulatByIdGroup(mc.Preconisations, iModIdGroupe), true)) > -1;
    }
    return false;
  }


  /**
    * Contrôle que la plot dispose d au - 1 micro avec 1 dose
    * selon preco Ident
    * @param CultivationPlot
    * @param iIdentPreco Plot Preco Ident
    */
  private IncludeMcPrecoDoseOnIdent(CultivationPlot: CultivationPlot, iIdentPreco: number): boolean {
    if (CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
      return CultivationPlot.MicroPlots.findIndex(mc => mc.Preconisations && this.IncludeFertiDose(this.GetPrecoByIdent(mc.Preconisations, iIdentPreco), true)) > -1;
    }
    return false;
  }

  /**
  * Contrôle que la plot dispose d au - 1 micro avec 1 dose
  * selon previs Ident
  * @param CultivationPlot
  * @param iIdentPreco Plot Preco Ident
  */
  private IncludeMcPrevisDoseOnIdent(CultivationPlot: CultivationPlot, iIdentPrevis: number): boolean {
    if (CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
      return CultivationPlot.MicroPlots.findIndex(mc => mc.InterPrevis && this.IncludeFertiDose(this.GetPrecoByIdent(mc.InterPrevis, iIdentPrevis), true)) > -1;
    }
    return false;
  }

  /**
   * Contrôle que la preco existe avec un ferti et une dose à celui ci
   * @param Preconisation
   * @param blCheckOver0Value Contrôle la présence d une dose Exclusivement superieur à 0 , si NON pas de contrôle de la valeur
   */
  private IncludeFertiDose(Preconisation: any, blCheckOver0Value: boolean): boolean {
    return (!this.IsEmptyFertiDose(Preconisation) && (blCheckOver0Value == false || Number(Preconisation.Fertilizer.Dose) > 0));
  }
  private IsEmptyFertiDose(Preconisation: any) {
    return (!Preconisation || !Preconisation.Fertilizer || (Preconisation.Fertilizer.Dose === null || Preconisation.Fertilizer.Dose === undefined))
  }

  /**
   * Retourne la micro preco selon son Ident
   * @param Preconisations ensemble des micro preconisations
   * @param _iPrecoIdent l'ident de la préconisation recherchée
   * @returns la préconisation avec cet Ident
   */
  private GetPrecoByIdent(Preconisations: mcPreconisation[], _iPrecoIdent: any) {
    return Preconisations.find(t => this.EqualByIdent(t, _iPrecoIdent));
  }

  /**
  * Retourne la micro modulation selon son IdGroup
  * @param Preconisations ensemble des micro modulations
  * @param _iPrecoIdent l'IdGroup de la modulation recherchée
  * @returns la modulation avec cet idGroup
  */
  private GetModulatByIdGroup(Modulations: mcPreconisation[], _iModIdGroup: any) {
    return Modulations.find(t => this.EqualByIdGroupe(t, _iModIdGroup));
  }
  private EqualByIdent(_imcPreco: mcPreconisation, _iIdent: number): boolean {
    return _imcPreco.Ident && _imcPreco.Ident != 0 && _imcPreco.Ident == _iIdent;
  }
  private EqualByIdGroupe(_imcPreco: mcPreconisation, _iIdGroupe: string): boolean {
    return _imcPreco.IdGroupe && isNullOrEmptyString(_imcPreco.IdGroupe) == false && _imcPreco.IdGroupe == _iIdGroupe;
  }

  private LogOnAnalytics(_iParams: PrecizionRequest) {
    if (this.selectedFormat && _iParams) {
      let _format = !this.isConsole ? this.selectedFormat : this.deviceSelected ? this.deviceSelected.Id : "";
      this.googleService.LogExportTerminal(_iParams.Products.length, _format, _iParams.blMergePrecos, _iParams.BufferSize, this.isConsole && _iParams.IsConnectedDevice == true);
    }
  }

  /**
   * Enregistre en mémoire le dernier format d'export console|Shapefile
   * @param _iFormat format d'export console|Shapefile
   */
  private SetMemoryExportFormat(_iSelectionFormat: string) {

    if (!_iSelectionFormat) {
     
      localStorageService.remove('exportPrecoFormat');
    } else {
      localStorageService.set('exportPrecoFormat', _iSelectionFormat);
    }
  }

  /**
  * récupère de la mémoire le dernier format d'export console|Shapefile
  * @param _iFormat format d'export console|Shapefile
  */
  private GetMemoryExportFormat() {
    return localStorageService.get('exportPrecoFormat');
  }

  /**
   * Indique si l'erreur API sur l'export correspond à un dépassement de taille de requête.
   * @param _iApiError L'erreur API à vérifier.
   * @returns true si l'erreur correspond à un dépassement de taille de requête, false sinon.
   */
  private IsReqSizeExceed(_iApiError:any){
    if(_iApiError && _iApiError.error &&  _iApiError.error.Detail && _iApiError.error.Detail.includes('request size exceeded')){
      return true;
    }
    return false;
  }

}
